import React from 'react';
import { render } from 'react-dom';

import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  createHttpLink,
  defaultDataIdFromObject,
  gql,
  from,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { offsetLimitPagination } from '@apollo/client/utilities';
import { setContext } from '@apollo/client/link/context';
import { GoogleOAuthProvider } from '@react-oauth/google';

import './i18n';
import App from './App';
import './index.css';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://9b04671adc8d4d23a845de4ac9c91278@o493982.ingest.sentry.io/5899568',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.05,

    // @ts-expect-error
    environment: window.django_environment,
  });
}
const httpLink = createHttpLink({
  uri: '/api/v2/graphql/',
  headers: {
    'Accept-Language': localStorage.getItem('i18nextLng') || 'en',
  },
});
const ralphQlContext = setContext((_, context) => {
  return {
    ...context,
    headers: {
      studyGroupId: context.studyGroupId,
    },
  };
});

// Create error handling link
const errorLink = onError(({ networkError }) => {
  if (
    networkError &&
    'statusCode' in networkError &&
    networkError.statusCode === 403
  ) {
    const response = (networkError as any)?.response;
    if (response && response.headers) {
      const licenseContext = response.headers.get('X-License-Context');
      if (licenseContext) {
        try {
          // Store the context in sessionStorage instead of URL params
          sessionStorage.setItem('licenseContext', licenseContext);
          window.location.href = '/license-expired';
          return;
        } catch (e) {
          console.error('Failed to parse license context:', e);
        }
      }
    }
    window.location.href = '/license-expired';
  }
});

export const client = new ApolloClient({
  link: from([errorLink, ralphQlContext.concat(httpLink)]),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        merge: true,
        fields: {
          studyGroups: {
            ...offsetLimitPagination(),
            merge(existing = [], incoming) {
              const eCopy = [...existing];
              incoming.forEach((inc: any) => {
                const itemIndex = eCopy.findIndex(
                  (exs: any) => exs.__ref === inc.__ref,
                );
                if (itemIndex === -1) {
                  eCopy.push(inc);
                } else {
                  eCopy[itemIndex] = inc;
                }
              });
              return [...eCopy];
            },
            // Don't cache separate results based on
            // any of this field's arguments.
            // keyArgs: ['pagination'],

            // // // Concatenate the incoming list items with
            // // // the existing list items.
            // merge(existing = [], incoming) {
            //   // console.log(existing, incoming);

            //   // const exs = existing.map((s) => s._ref);
            //   // // const inc = existing.map((s) => s._ref);

            //   // const ret = [];

            //   return [...existing, ...incoming];
            // },
            // read(existing, { args, canRead }) {
            //   console.log(existing, args);
            //   if (existing && args && args.pagination)
            //     return existing.filter((s: any) =>
            //       canRead({ from: s, fieldName: 'license' }),
            //     );
            //   return existing;
            // },
          },
        },
      },
    },
    dataIdFromObject(responseObject) {
      if (responseObject.pk != null) {
        return `${responseObject.__typename}:${responseObject.pk}`;
      }
      if (responseObject.id != null) {
        return `${responseObject.__typename}:${responseObject.id}`;
      }
      return defaultDataIdFromObject(responseObject);
    },
  }),
  headers: {},
});

render(
  <GoogleOAuthProvider clientId="444537418234-83mc3uoppqkio8ftsun898nqddgh7au0.apps.googleusercontent.com">
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </GoogleOAuthProvider>,
  document.getElementById('root'),
);
